/**
 * Single personal numerology report product — full written interpretation only.
 * Legacy tier names kept as constants for internal bundle keys only (always FULL).
 */

export const TIERS = {
  FULL: 'full',
};

/** Always the complete report — no mini / premium / depth selection. */
export function resolveTierFromEnv() {
  return TIERS.FULL;
}

export function resolveTierFromBrowser() {
  return TIERS.FULL;
}

export const SECTION_KEYS = {
  reportSummary: 'reportSummary',
  chartOneSentence: 'chartOneSentence',
  corePattern: 'corePattern',
  coreNumbers: 'coreNumbers',
  repeatingPatterns: 'repeatingPatterns',
  tension: 'tension',
  lifeAreas: 'lifeAreas',
  currentCycle: 'currentCycle',
  focusNow: 'focusNow',
  reflectionPrompts: 'reflectionPrompts',
  methodology: 'methodology',
  advancedCourseParity: 'advancedCourseParity',
};

const ALL_SECTIONS = new Set(Object.values(SECTION_KEYS));

export function tierAllows(_tier, sectionKey) {
  return ALL_SECTIONS.has(sectionKey);
}
